import React from 'react';
import PropTypes from 'prop-types';
import { TableCell, TableSortLabel, makeStyles } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import { myTableHeadCellPropTypes, defaultMyTableHeadCellPropTypes } from './my-table-prop-types';

const useStyles = makeStyles((theme) => ({
  labelActive: {
    fontWeight: theme.typography.fontWeightBold,
  },
}));

const MyTableHeadCell = (props) => {
  const {
    name,
    type,
    align,
    padding,
    sorting,
    labelId,

    orderBy,
    orderDirection,
    onRequestSort,
  } = props;
  const classes = useStyles();

  let headCell;
  switch (type) {
    case 'actions':
      headCell = (
        <TableCell
          align={align}
          padding={padding ? 'default' : 'none'}
        >
          <FormattedMessage id="seed.MyTable.actions" />
        </TableCell>
      );
      break;
    default:
      headCell = (
        <TableCell
          align={align}
          padding={padding ? 'default' : 'none'}
          sortDirection={sorting && orderBy === name
            ? orderDirection : false}
        >
          {
          // eslint-disable-next-line no-nested-ternary
          sorting ? (
            <TableSortLabel
              classes={{
                active: classes.labelActive,
              }}
              active={orderBy === name}
              direction={orderBy === name ? orderDirection : 'asc'}
              onClick={() => onRequestSort(name)}
            >
              {
                labelId ? <FormattedMessage id={labelId} /> : ''
              }
            </TableSortLabel>
          ) : (
            labelId ? <FormattedMessage id={labelId} /> : ''
          )
        }
        </TableCell>
      );
      break;
  }

  return headCell;
};

MyTableHeadCell.propTypes = {
  ...myTableHeadCellPropTypes,

  orderBy: PropTypes.string.isRequired,
  orderDirection: PropTypes.string.isRequired,
  onRequestSort: PropTypes.func.isRequired,
};

MyTableHeadCell.defaultProps = defaultMyTableHeadCellPropTypes;

export default MyTableHeadCell;
